import { Link } from "react-router-dom";
import { Brain, Loader2, Lock } from "lucide-react";

export function PersonalPanel({ personal, onStart, busy }) {
  if (personal.locked) {
    return (
      <div className="card p-6" data-testid="personal-locked">
        <div className="flex items-center gap-2 font-semibold"><Lock size={15} className="text-[#E50914]" /> Personalised quizzes are Pro</div>
        <p className="text-sm text-[#A1A1AA] mt-1.5">Pro reads what you're training and struggling with, then tests the technique behind it: positioning, grips, angles, common mistakes and the right decisions.</p>
        <Link to="/pro" className="btn-primary w-full mt-5" data-testid="personal-upgrade-button">See Pro</Link>
      </div>
    );
  }
  if (!personal.session_count) {
    return (
      <div className="card p-6 text-center" data-testid="personal-empty">
        <div className="font-semibold">Log a session first</div>
        <p className="text-sm text-[#A1A1AA] mt-1">We build technical questions around the positions and techniques you log.</p>
        <Link to="/" className="btn-primary mt-5" data-testid="personal-log-button">Log a session</Link>
      </div>
    );
  }
  return (
    <div className="card p-5" data-testid="personal-ready">
      <div className="eyebrow mb-1.5">Training quiz</div>
      <p className="text-sm text-[#D4D4D8]">Technical questions on what you're working on, plus topics you've missed in quizzes.</p>
      {personal.focus.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mt-3" data-testid="personal-focus">
          {personal.focus.map((f) => <span key={f} className="text-xs capitalize rounded-full bg-white/5 border border-[#1F1F23] px-2.5 py-1">{f}</span>)}
        </div>
      )}
      <button data-testid="personal-start-button" onClick={onStart} disabled={busy} className="btn-primary w-full mt-5">
        {busy ? <Loader2 size={16} className="animate-spin" /> : <><Brain size={16} /> Start training quiz</>}
      </button>
      <p className="text-[11px] text-[#71717A] mt-2.5">Practice only: personalised quizzes don't award XP.</p>
    </div>
  );
}
